<template>
  <TransitionGroup :name="listName" tag="ul" class="base-scoped-list el-upload-list el-upload-list--text" :class="finalClass" :style="finalStyle">
    <li v-for="(item, index) in items" :key="index" tabindex="0" class="base-scoped-list--item el-upload-list-item el-upload-list__item is-ready" >
      <base-scoped-list-item v-on="$listeners" v-bind="$props" :item="item" :hide-open-action="hideOpenAction || hideOpenItemActionsCallback(item)"
        :hide-status="hideStatus || hideStatusItemCallback(item)">
        <template v-if="$slots.default || $scopedSlots.default" slot="default" slot-scope="{ item }">
          <slot name="default" :item="item" />
        </template>
        <template v-if="$slots.actions || $scopedSlots.actions" slot="actions" slot-scope="{ item }">
          <slot name="actions" :item="item" />
        </template>
        <template v-if="$slots.status || $scopedSlots.status" slot="status" slot-scope="{ item }">
          <slot name="status" :item="item" />
        </template>
      </base-scoped-list-item>
    </li>
  </TransitionGroup>
</template>

<script>
import ScopedItemProperties from '@/classes/scoped-list/ScopedItemProperties'

export default {
  name: 'base-scoped-list',
  components: {
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    maxHeight: {
      type: [String, Number],
      default: 'unset'
    },
    listName: {
      type: String,
      default: 'el-list'
    },
    deep: {
      type: [Number, Boolean],
      default: false
    },
    hideOpenAction: {
      type: Boolean,
      default: false
    },
    hideStatus: {
      type: Boolean,
      default: false
    },
    hideOpenItemActionsCallback: {
      type: Function,
      default: item => false
    },
    hideStatusItemCallback: {
      type: Function,
      default: item => false
    },
    defaultOpenAll: {
      type: Boolean,
      default: false
    },
    openOnClickNode: {
      type: Boolean,
      default: false
    },
    defaultOpenedKeys: {
      type: Array,
      default: () => []
    },
    noneSpace: {
      type: Boolean,
      default: false,
    },
    reverseColors: {
      type: Boolean,
      default: false,
    },
    custom: {
      type: [String, Object],
      default: ''
    },
    props: {
      type: ScopedItemProperties,
      default: () => new ScopedItemProperties()
    }
  },
  data () {
    return {
      levelClass: '',
    }
  },
  mounted () {
    this.applyLevelClass()
  },
  watch: {
    reverseColors: function (value, oldValue) {
      if (value !== oldValue) {
        this.applyLevelClass()
      }
    }
  },
  computed: {
    finalCustomClass: function () {
      if (typeof this.custom === 'string') {
        if (this.custom.trim() === '') {
          return {}
        }
        return { [this.custom]: true }
      }
      return this.custom
    },
    finalClass: function () {
      return { [this.levelClass]: true, ...this.finalCustomClass, 'none-space': this.noneSpace }
    },
    finalMaxHeight: function () {
      if (typeof this.maxHeight === 'number') {
        return `${this.maxHeight}px !important`
      }
      return `${this.maxHeight} !important`
    },
    finalStyle: function () {
      return { 'max-height': this.finalMaxHeight }
    },
    fixedProps: function () {
      return Object.assign(new ScopedItemProperties(), this.props)
    }
  },
  methods: {
    countUploaditemListAncestors () {
      var count = 0
      var parent = this.$parent
      while (parent) {
        if (parent.$options.name === 'base-scoped-list') {
          count++
        }
        parent = parent.$parent
      }
      return count
    },
    applyLevelClass () {
      const ancestorCount = this.countUploaditemListAncestors()
      if (this.reverseColors) {
        this.levelClass = ancestorCount % 2 !== 0 ? 'even-level' : 'odd-level'
      } else {
        this.levelClass = ancestorCount % 2 === 0 ? 'even-level' : 'odd-level'
      }
    },
  },
}
</script>

<style scoped>
.base-scoped-list > .base-scoped-list--item {
  margin-top: 5px;
}
.base-scoped-list:not(.none-space) > .base-scoped-list--item:first-child {
  margin-top: 10px;
}
.base-scoped-list {
  padding-bottom: 10px;
}
.base-scoped-list.none-space {
  padding-bottom: 5px;
}

.base-scoped-list.even-level > .base-scoped-list--item:hover {
  background-color: var(--secondary-50);
 }
 
 .dark .base-scoped-list.even-level > .base-scoped-list--item:hover {
  background-color: var(--darkblue-200);
 }
 
.base-scoped-list.odd-level > .base-scoped-list--item:hover {
  background-color: var(--secondary-100);
}
.dark .base-scoped-list.odd-level > .base-scoped-list--item:hover {
  background-color: var(--darkblue-100);
}
</style>
